import { usePageWrapperContext } from '@innovyze/stylovyze/lib/hocs/PageWrapper/utils/PageWrapperContext';
import { useEffect } from 'react';
import { useStylovyzeFormContext } from '../contexts/StylovyzeFormContext';
export const useListenStylovyzeForm = ({ showSecondaryAction, dirty, }) => {
    const { stylovyzeFields } = useStylovyzeFormContext();
    const { setPageWrapperStylovyzeFields = () => { }, setShowSecondaryAction = () => { }, setIsDirty, } = usePageWrapperContext();
    useEffect(() => {
        if (setIsDirty)
            setIsDirty(dirty);
    }, [dirty]);
    useEffect(() => {
        setPageWrapperStylovyzeFields(stylovyzeFields);
        return () => {
            if (setPageWrapperStylovyzeFields) {
                setPageWrapperStylovyzeFields(null);
            }
        };
    }, [stylovyzeFields]);
    useEffect(() => {
        setShowSecondaryAction(!!showSecondaryAction);
        return () => {
            if (setShowSecondaryAction) {
                setShowSecondaryAction(false);
            }
        };
    }, [showSecondaryAction]);
};
export default useListenStylovyzeForm;
